<template>
    <div id="mainTrainers">
        <router-view> </router-view>
    </div>
</template>

<script>
    export default {
    name: "mainTrainers"
    }
</script>